import React, { useContext } from 'react';
import 'twin.macro';
import { CommentsContext, ModerationContextProvider } from '../context/';

export const ModerationWrapper = ({ children }) => {
  const { commentsList } = useContext(CommentsContext);

  const getIds = (list, condition) => list.filter((item) => condition(item)).map((item) => item.id);

  const getChildIds = (list, condition) =>
    list
      .filter((item) => item.child_comments && item.child_comments.length > 0)
      .flatMap((item) => getIds(item.child_comments, condition));

  const removedCondition = (item) => !item.approved && !item.banned;
  const bannedCondition = (item) => !item.approved && item.banned;
  const hiddenCondition = (item) => item.hidden;

  const removedList = [
    ...getIds(commentsList, removedCondition),
    ...getChildIds(commentsList, removedCondition),
  ];
  const bannedList = [
    ...getIds(commentsList, bannedCondition),
    ...getChildIds(commentsList, bannedCondition),
  ];
  const hiddenList = [
    ...getIds(commentsList, hiddenCondition),
    ...getChildIds(commentsList, hiddenCondition),
  ];

  return (
    <ModerationContextProvider
      removedList={removedList}
      bannedList={bannedList}
      hiddenList={hiddenList}
    >
      {children}
    </ModerationContextProvider>
  );
};
